import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import config from "../../config"
const Vas = () => {
  let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====shipments====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
  const [vasStatus, setVasStatus] = useState({
    delivery_updates: false,
    human_ndr: false,
    cod_verification: false,
  });
  const [vasPrice, setVasPrice] = useState({
    delivery_update_price: 0,
    cod_verification_price: 0,
  });

 useEffect(()=>{
  fetchVasStatus()
  fetchVasPrices()
 },[])
 
    const fetchVasStatus = async () => {
      try {
        let full_api =  config.apiUrl + '/user/get_vas_status';
          let sendData = {customer_id:userData.customer_id}
        
        const res = await axios.post(full_api,sendData, { headers: config.headers });
        if (res.data && res.data.status) {
          setVasStatus(res.data.status); 
        }
      } catch (err) {
        console.error("Failed to fetch VAS status", err);
      }
    };

    const fetchVasPrices = async () => {
      try {
        let full_api =  config.apiUrl + '/user/get_vas_prices';
          let sendData = {customer_id:userData.customer_id}
        
        const res = await axios.post(full_api,sendData, { headers: config.headers });
        setVasPrice({ delivery_update_price: res.data.delivery_update_price,
          cod_verification_price: res.data.cod_verification_price})
      } catch (err) {
        console.error("Failed to fetch VAS status", err);
      }
    };

  

  // 🔁 Toggle handler
  const handleToggle = async (key) => {
    const updatedValue = !vasStatus[key];
    const updatedStatus = { ...vasStatus, [key]: updatedValue };
    setVasStatus(updatedStatus);

    try {
      let full_api =  config.apiUrl + '/user/update_vas';
      let sendData = {customer_id:userData.customer_id , [key]: updatedValue}
      await axios.post(full_api,sendData, { headers: config.headers });
    } catch (err) {
      console.error("Failed to update VAS:", err);
    }
  };

  return (
    <div>
      <Header />
      <div className="page-wrapper pinned">
        <div className="main-container">
          <div className="app-container">
            <div className="app-body">
              <div className="container-fluid">

                <div className="row justify-content-between">
                  <div className="col-12 col-md desk_nav">
                    <div className="d-flex">
                      <a href="javascript:window.history.back();" className="back_btn">
                        <i className="bi bi-arrow-90deg-left"></i>
                      </a>
                      <h2>Value Added Services (VAS)</h2>
                    </div>
                  </div>
                </div>

                <div className="card data_table mb-3 mb_display_none">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="shipm_tablew rounded-3">
                        <table className="table table-striped table-hover m-0 table-xl">
                          <thead>
                            <tr>
                              <th>Value Added Services (VAS)</th>
                              <th>Charges</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              { label: 'Delivery Alerts on WhatsApp with Product Image', key: 'delivery_updates', original: `₹${vasPrice.delivery_update_price }`  },
                              // { label: 'Complete NDR Management with Audio Playback and Refund Guarantee', key: 'human_ndr', original: '₹12.99', final: '₹0' },
                              { label: 'COD Verification with Product Image', key: 'cod_verification', original: `₹${vasPrice.cod_verification_price }` }
                            ].map(service => (
                              <tr key={service.key}>
                                <td>{service.label}</td>
                                <td className="fw-bold"> {service.original}</td>
                                <td>
                                  <div className="d-flex justify-content-start">
                                    <div>
                                      <div className="form-check form-switch mb-2">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={vasStatus[service.key]}
                                          onChange={() => handleToggle(service.key)}
                                        />
                                      </div>
                                    </div>
                                    <div>
                                      <span className={`badge ${vasStatus[service.key] ? "bg-success" : "bg-danger"}`}>
                                        {vasStatus[service.key] ? "On" : "Off"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <h2 className='text-danger'>*All prices shown are inclusive of GST.</h2>
              
              </div>
            </div>
          </div>
          <Footer />
        </div>
       
      </div>
    </div>
  );
};

export default Vas;
